import { isElectronApp } from '#~/electron/utils.js';
import * as electronStoreFns from './store.electron.js';
import * as webStoreFns from './store.web.js';

const isElectron = isElectronApp();

const storeFns: {
  get: (key: string) => Promise<string | null>;
  set: (key: string, value: string) => Promise<void>;
  remove: (key: string) => Promise<void>;
  clear: () => Promise<void>;
  keys: () => Promise<string[]>;
} = isElectron ? electronStoreFns : webStoreFns;

const { get, set, remove, clear, keys } = storeFns;

export { get, set, remove, clear, keys };
